import { render } from "./workflow-status-change-form.vue?vue&type=template&id=9a98b4e9&scoped=true"
import script from "./workflow-status-change-form.vue?vue&type=script&lang=js"
export * from "./workflow-status-change-form.vue?vue&type=script&lang=js"

import "./workflow-status-change-form.vue?vue&type=style&index=0&id=9a98b4e9&scoped=true&lang=scss"

import exportComponent from "../../../../../../../../node_modules/rspack-vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9a98b4e9"]])

export default __exports__